/* Balkan — filtrul şi sortarea din antetul de recenzii (macheta 7 oct. 2026).

   Totul se face pe cardurile deja randate: datele sunt în `data-bk-data`,
   `data-bk-nota` şi `data-bk-poze`, scrise de Liquid. Nu se cere nimic de la
   server şi nicio dată nu e formatată în JavaScript.
   ⚠️ Sortarea respectă butonul „arată toate": cardurile ascunse rămân ascunse,
   doar îşi schimbă ordinea — altfel o sortare ar dezvălui tot setul pe tăcute. */
(() => {
  const bara = document.querySelector('[data-bk-rev2]');
  const lista = document.querySelector('[data-bk-revs]');
  if (!bara || !lista) return;

  const carduri = () => [...lista.querySelectorAll('.bk-rev')];

  bara.querySelectorAll('[data-bk-filt]').forEach((b) => {
    b.addEventListener('click', () => {
      bara.querySelectorAll('[data-bk-filt]').forEach((x) => x.removeAttribute('data-bk-on'));
      b.setAttribute('data-bk-on', '');
      const doarPoze = b.getAttribute('data-bk-filt') === 'poze';
      carduri().forEach((c) => {
        const are = Number(c.getAttribute('data-bk-poze') || 0) > 0;
        c.toggleAttribute('data-bk-filtrat', doarPoze && !are);
      });
    });
  });

  const sel = bara.querySelector('[data-bk-sort]');
  sel?.addEventListener('change', () => {
    const cum = sel.value;
    const c = carduri();
    c.sort((a, b) => {
      if (cum === 'nota-mare') return Number(b.dataset.bkNota) - Number(a.dataset.bkNota);
      if (cum === 'nota-mica') return Number(a.dataset.bkNota) - Number(b.dataset.bkNota);
      return (b.dataset.bkData || '').localeCompare(a.dataset.bkData || '');
    });
    c.forEach((x) => lista.appendChild(x));
  });
})();
